import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SagresService {
  private readonly apiRoot = 'https://api-relatorios-php.elogica.info';
  private readonly sagresBase = `${this.apiRoot}/sagres`;
  private readonly basicUser = '3l0g1k4';
  private readonly basicPass = 'dtr5x8!qAa6>';

  constructor(private http: HttpClient) {}

  private getAuthHeaders(accept?: string): HttpHeaders {
    const credentials = btoa(`${this.basicUser}:${this.basicPass}`);
    let headers = new HttpHeaders({ Authorization: `Basic ${credentials}` });
    if (accept) headers = headers.set('Accept', accept);
    return headers;
  }

  listarCompetencias(sigla: string, empfil: string): Observable<any> {
    const url = `${this.apiRoot}/competencias-folha/${sigla}/${empfil}`;

    const headers = this.getAuthHeaders('application/json');

    return this.http.get(url, { headers }).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        console.error('❌ Erro ao carregar competências:', error);
        return throwError(() => error);
      })
    );
  }

  buscarDependentes(sigla: string, dtcomp: string, empfil: string): Observable<any[]> {
    const url = `${this.sagresBase}/dependente/${sigla}/${dtcomp}/${empfil}`;
    const headers = this.getAuthHeaders('application/json');
  
    return this.http.get(url, { headers }).pipe(
      map((response: any) => {
        let contentData = [];
  
        if (response?.result?.content) {
          contentData = response.result.content;
        } else if (response?.content) {
          contentData = response.content;
        } else if (Array.isArray(response)) {
          contentData = response;
        } else if (response?.result && Array.isArray(response.result)) {
          contentData = response.result;
        }
  
        return contentData;
      }),
      catchError((error) => {
        console.error('❌ Erro ao buscar dependentes:', error);
        return throwError(() => error);
      })
    );
  }
  

  buscarFolhaPagamentoContent(sigla: string, dtcomp: string, empfil: string): Observable<any> {
    const url = `${this.sagresBase}/folha-pagamento/${sigla}/${dtcomp}/${empfil}`;
    const headers = this.getAuthHeaders('application/json');

    return this.http.get(url, { headers }).pipe(
      map((response: any) => {
        let contentData = [];

        if (response?.content) {
          contentData = Array.isArray(response.content) ? response.content : [];
        } else if (response?.result?.content) {
          contentData = Array.isArray(response.result.content) ? response.result.content : [];
        } else if (response?.file) {
          try {
            const xmlString = atob(response.file);
            const contentMatch = xmlString.match(/<content>\[.*?\]<\/content>/);
            if (contentMatch) {
              const contentJson = contentMatch[0].replace(/<content>|<\/content>/g, '');
              contentData = JSON.parse(contentJson);
            }
          } catch (error) {
            console.error('❌ Erro ao extrair content do file:', error);
          }
        } else if (Array.isArray(response)) {
          contentData = response;
        } else if (response?.result && Array.isArray(response.result)) {
          contentData = response.result;
        }

        return contentData;
      }),
      catchError((error) => {
        console.error('❌ Erro ao buscar folha de pagamento:', error);
        return throwError(() => error);
      })
    );
  }

  buscarFolhaPagamento(sigla: string, dtcomp: string, empfil: string): Observable<any[]> {
    const url = `${this.sagresBase}/folha-pagamento/${sigla}/${dtcomp}/${empfil}`;
    const headers = this.getAuthHeaders('application/json');

    return this.http.get(url, { headers }).pipe(
      map((response: any) => {
        if (Array.isArray(response)) {
          return response;
        } else if (response?.content && Array.isArray(response.content)) {
          return response.content;
        } else if (response?.result?.content && Array.isArray(response.result.content)) {
          return response.result.content;
        } else if (response?.result && Array.isArray(response.result)) {
          return response.result;
        } else {
          return [];
        }
      }),
      catchError((error) => {
        console.error('❌ Erro ao buscar folha de pagamento:', error);
        return throwError(() => error);
      })
    );
  }

  buscarVantagemDesconto(sigla: string, dtcomp: string, empfil: string): Observable<any> {
    const url = `${this.sagresBase}/vantagem-desconto/${sigla}/${dtcomp}/${empfil}`;
    const headers = this.getAuthHeaders('application/json');

    return this.http.get(url, { headers }).pipe(
      map((response: any) => {
        let contentData = [];
        let totais = null;

        if (response?.result?.content) {
          contentData = response.result.content;
          totais = response.result?.totais ?? response.totais ?? null;
        } else if (response?.content) {
          contentData = response.content;
          totais = response.totais ?? null;
        } else if (Array.isArray(response)) {
          contentData = response;
        }

        return { content: contentData, totais };
      }),
      catchError((error) => {
        console.error('❌ Erro ao buscar vantagem-desconto:', error);
        return throwError(() => error);
      })
    );
  }

  buscarServidores(sigla: string, dtcomp: string, empfil: string): Observable<any> {
    const url = `${this.sagresBase}/servidor/${sigla}/${dtcomp}/${empfil}`;
    const headers = this.getAuthHeaders('application/json');

    return this.http.get(url, { headers }).pipe(
      map((response: any) => {
        let contentData = [];

        if (response?.result?.content) {
          contentData = response.result.content;
        } else if (response?.content) {
          contentData = response.content;
        } else if (Array.isArray(response)) {
          contentData = response;
        }

        return { content: contentData };
      }),
      catchError((error) => {
        console.error('❌ Erro ao buscar servidores:', error);
        return throwError(() => error);
      })
    );
  }

  baixarXml(endpoint: string, sigla: string, dtcomp: string, empfil: string): Observable<string> {
    const url = `${this.sagresBase}/${endpoint}/${sigla}/${dtcomp}/${empfil}`;
    const headers = this.getAuthHeaders('text/plain');

    return this.http.get(url, { headers, responseType: 'text' }).pipe(
      map((response: string) => {
        if (!response) throw new Error(`Resposta vazia para ${endpoint}`);

        const maybeJson = this.safeParseJson(response);
        let xmlContent: string;

        if (maybeJson && (maybeJson.result?.file || maybeJson.file || maybeJson.Base64)) {
          xmlContent = maybeJson.result?.file ?? maybeJson.file ?? maybeJson.Base64;
        } else {
          xmlContent = response;
        }

        if (this.isBase64(xmlContent)) return xmlContent;

        try {
          const utf8 = new TextEncoder().encode(xmlContent);
          let binary = '';
          utf8.forEach((b) => (binary += String.fromCharCode(b)));
          return btoa(binary);
        } catch (err) {
          console.error(`Erro ao converter ${endpoint} para base64:`, err);
          throw new Error(`Falha ao processar XML ${endpoint}`);
        }
      }),
      catchError((error) => {
        console.error(`Erro ao baixar ${endpoint}:`, error);
        return throwError(() => error);
      })
    );
  }

  private safeParseJson(text: string): any | null {
    try {
      return JSON.parse(text);
    } catch {
      return null;
    }
  }

  private isBase64(str: string): boolean {
    if (typeof str !== 'string') return false;
    try {
      return btoa(atob(str)) === str;
    } catch {
      return false;
    }
  }
}
